export const getCountries = (state) => state.countries
export const getGenders = (state) => state.genders
export const getPieceTypes = (state) => state.pieces
export const getAges = (state) => state.ages

